export function handleUserCount(count) {
  if (count > 9999) {
    return `${(count / 10000).toFixed(1)}万`;
  } else {
    return count;
  }
}
